var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-controls" }, [
    _c("div", { staticClass: "c-controls__group" }, [
      _c("label", { staticClass: "c-controls__label" }, [_vm._v("Storycubes")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button button--control",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.throwDice.apply(null, arguments)
            }
          }
        },
        [_vm._v("Dobbelen")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }